import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the exercise slice
const initialState = {
  activeExercise: null, // This will store the currently active exercise component
};

// Create a Redux slice for handling exercise-related state
const exerciseSlice = createSlice({
  name: "exercise", // Name of the slice
  initialState, // The initial state defined above
  reducers: {
    // Reducer to set the active exercise component
    setActiveExercise: (state, action) => {
      state.activeExercise = action.payload; // Update the activeExercise with the provided payload
    },
    // Reducer to clear the active exercise, resetting it to null
    clearActiveExercise: (state) => {
      state.activeExercise = null; // Reset the activeExercise to null
    },
  },
});

export const { setActiveExercise, clearActiveExercise } = exerciseSlice.actions;

export default exerciseSlice.reducer;
